/* @flow */
const prefix = str => `station/cpe/${str}`;

export const CLEAR_INDICATORS = prefix('CLEAR_INDICATORS');

export const DELETE_INDICATOR = prefix('DELETE_INDICATOR');
export const DELETE_INDICATOR_FAILURE = prefix('DELETE_INDICATOR_FAILURE');

export const SET_TIME_RANGE = prefix('SET_TIME_RANGE');
export const SET_TIME_RANGE_SUCCESS = prefix('SET_TIME_RANGE_SUCCESS');

export const PAGINATE_INDICATOR_LIST = prefix('PAGINATE_INDICATOR_LIST');
export const REFRESH_INDICATOR_LIST = prefix('REFRESH_INDICATOR_LIST');
export const STORE_INDICATOR_LOCAL = prefix('STORE_INDICATOR_LOCAL');

export const FETCH_INDICATOR_LIBRARY = prefix('FETCH_INDICATOR_LIBRARY');
export const FETCH_INDICATOR_LIBRARY_SUCCESS = prefix('FETCH_INDICATOR_LIBRARY_SUCCESS');
export const FETCH_INDICATOR_LIBRARY_FAILURE = prefix('FETCH_INDICATOR_LIBRARY_FAILURE');

export const SET_INDICATOR_FETCH_OPTIONS = prefix('SET_INDICATOR_FETCH_OPTIONS');

export const FETCH_INDICATOR_METADATA = prefix('FETCH_INDICATOR_METADATA');
export const FETCH_INDICATOR_METADATA_SUCCESS = prefix('FETCH_INDICATOR_METADATA_SUCCESS');
export const FETCH_INDICATOR_METADATA_FAILURE = prefix('FETCH_INDICATOR_METADATA_FAILURE');

export const FETCH_INDICATORS_FOR_TAG = prefix('FETCH_INDICATORS_FOR_TAG');
export const FETCH_INDICATORS_FOR_TAG_SUCCESS = prefix('FETCH_INDICATORS_FOR_TAG_SUCCESS');
export const FETCH_INDICATORS_FOR_TAG_FAILURE = prefix('FETCH_INDICATORS_FOR_TAG_FAILURE');

export const FETCH_IOC_ENRICHMENT = prefix('FETCH_IOC_ENRICHMENT');
export const FETCH_IOC_ENRICHMENT_SUCCESS = prefix('FETCH_IOC_ENRICHMENT_SUCCESS');
export const FETCH_IOC_ENRICHMENT_FAILURE = prefix('FETCH_IOC_ENRICHMENT_FAILURE');

export const REVERT_CLASSIFICATION = prefix('REVERT_CLASSIFICATION');
export const REVERT_CLASSIFICATION_SUCCESS = prefix('REVERT_CLASSIFICATION_SUCCESS');
export const REVERT_CLASSIFICATION_FAILURE = prefix('REVERT_CLASSIFICATION_FAILURE');

export const EXPORT_INDICATORS_LIST = prefix('EXPORT_INDICATORS_LIST');
export const EXPORT_INDICATORS_LIST_SUCCESS = prefix('EXPORT_INDICATORS_LIST_SUCCESS');
export const EXPORT_INDICATORS_LIST_FAILURE = prefix('EXPORT_INDICATORS_LIST_FAILURE');

export const EXPORT_INDICATORS_FOR_TAG = prefix('EXPORT_INDICATORS_FOR_TAG');
export const EXPORT_INDICATORS_FOR_TAG_SUCCESS = prefix('EXPORT_INDICATORS_FOR_TAG_SUCCESS');
export const EXPORT_INDICATORS_FOR_TAG_FAILURE = prefix('EXPORT_INDICATORS_FOR_TAG_FAILURE');



// WEBPACK FOOTER //
// ./src/app/modules/indicators/action-types.js